var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-checkbox',{attrs:{"label":"None of the above","value":_vm.isChecked},on:{"input":function($event){return _vm.changeAnswer()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }